<template>
  <AdministrationHeader>
    <!-- Un autre groupe dans l'adresse : tout est rechargé -->
    <AdministrationPanel :key="$route.params.id" :load="load" v-slot="{ data, reload }">
      <h1><span>Administration / <router-link to="/administration/groups">Groupes</router-link> / </span>{{ groupLabel(data.group.name) }}</h1>
      <GroupDetail :data="data" :callback="reload" />
    </AdministrationPanel>
  </AdministrationHeader>
</template>

<script>
import AdministrationHeader from "@/administration/components/AdministrationHeader.vue";
import AdministrationPanel from "@/administration/components/AdministrationPanel.vue";
import GroupDetail from "@/administration/components/GroupDetail.vue";
import {AdministrationController} from "@/administration/controllers/AdministrationController";
import {groupLabel} from "@/administration/utils";

export default {
  name: 'AdministrationGroupView',
  components: {AdministrationHeader, AdministrationPanel, GroupDetail},
  methods: {
    groupLabel,
    load() {
      return AdministrationController.getGroup(this.$route.params.id);
    },
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY
  span
    color THEME_COLOR_PRIMARY_FADDED

  a
    color inherit
    text-decoration none

    &:hover
      text-decoration underline
</style>
